import Swiper from 'swiper';
import { Manipulation, Navigation, Pagination, Zoom, Thumbs } from 'swiper/modules';

function setSwiperHeight(mainSlider) {
  const wrapper = mainSlider.wrapperEl;
  const slides = mainSlider.slides;

  let totalHeight = 0;

  // Calcula a altura total dos slides
  slides.forEach((slide) => {
    totalHeight += slide.offsetHeight;
  });

  // Define a altura total como a altura do .swiper-wrapper
  wrapper.style.height = `${totalHeight}px`;

  // Força a atualização do Swiper
  mainSlider.updateSlides();
  mainSlider.updateSlidesOffset();
  mainSlider.update();
}

export default function setGallery(Product) {
  const productImagesContainer = document.querySelector('[data-product-images]');

  const thumbs = new Swiper(Product.thumbsSlider.element, {
    modules: [Manipulation],
    direction: 'vertical',
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 16,
    watchSlidesProgress: true,
    watchOverflow: true,
  });

  const main = new Swiper(Product.mainSlider.element, {
    modules: [Manipulation, Navigation, Pagination, Zoom, Thumbs],
    slidesPerView: 1,
    spaceBetween: 4,
    speed: 1000,
    watchSlidesProgress: true,
    watchOverflow: true,
    centeredSlides: true,
    virtualTranslate: window.mobile ? false : true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '[data-main-slider] .swiper-button-next',
      prevEl: '[data-main-slider] .swiper-button-prev',
    },
    pagination: {
      el: '.product-images .swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    zoom: {
      maxRatio: 1.5,
      zoomedSlideClass: '-zoomed',
    },
    breakpoints: {
      992: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 8,
        centeredSlides: false,
      },
    },
    
    on: {
      zoomChange: (swiper, scale, imageEl, slideEl) => {
        setTimeout(() => {
          if (slideEl.classList.contains('-zoomed')) {
            productImagesContainer.classList.add('-zoomed');
          } else {
            productImagesContainer.classList.remove('-zoomed');
          }
        }, 500);
      },
    },
  });

  Product.thumbsSlider.swiper = thumbs;
  Product.mainSlider.swiper = main;

  !window.mobile && main.on('init', () => {
     setSwiperHeight(main);
  });

}
